import {FC, useState} from 'react'
import {useIntl} from 'react-intl'
import TransactionReportTableRow from './TransactionReportTableRow'
import {ITransactionReportModel, ITotalTransactionRow} from '../core/_models'
import '../../../stylesheet/transactionReport.css'
import { useLocation } from 'react-router-dom';
import {currencyLabel} from '../../common/currencyLabel'
interface IProps {
    data: ITransactionReportModel[];
    transactionTotal?: ITotalTransactionRow | null;
}

const TransactionReportTable: FC<IProps> = ({data, transactionTotal}) => {

    console.log(transactionTotal);
    const {formatMessage} = useIntl()
    // Currency is data-driven: use the report's own currency when the API
    // supplies it, falling back to the JOD label for legacy responses.
    const currencyString = currencyLabel(transactionTotal?.currency, formatMessage)
    const barcodePrintingNet = Number(transactionTotal?.total_barcode_printing_net ?? 0) || 0
    const [modalParam, setModalParam] = useState<{ show: boolean, data: ITransactionReportModel | null }>({
        show: false,
        data: null
    });

    const toggleModal = (params?: ITransactionReportModel) => {
        setModalParam((prev) => ({
            data: params ? params : prev.data,
            show: !modalParam.show
        }))
    }

    const useQueryDates = () => {
        const location = useLocation();
        const queryParams = new URLSearchParams(location.search);

        return {
            getDateStart: (): string => queryParams.get('filter_date_start') || '',
            getDateEnd: (): string => queryParams.get('filter_date_end') || '',
        };
    };

    const { getDateStart, getDateEnd } = useQueryDates();

    return (
        <>
            <table className='table align-middle gs-0 gy-5'>
                <thead>
                <tr>
                    <th className="fw-bold p-0 px-2 text-nowrap text-uppercase">
                        {formatMessage({id: 'image'})}
                    </th>
                    <th className="fw-bold p-0 px-2 text-nowrap text-uppercase">
                        {formatMessage({id: 'barcode'})}
                    </th>
                    <th className="fw-bold p-0 px-2 text-nowrap text-uppercase">
                        {formatMessage({id: 'model_num'})}
                    </th>
                    <th className="fw-bold p-0 text-uppercase">
                        {formatMessage({id: 'prod_name'})}
                    </th>
                    <th className="fw-bold p-0 px-2 text-uppercase">
                        {formatMessage({id: 'transaction_type'})}
                    </th>
                    <th className="fw-bold p-0 px-2 text-uppercase">
                        {formatMessage({id: 'transaction_date'})}
                    </th>
                    <th className="fw-bold p-0 px-2 text-uppercase">
                        {formatMessage({id: 'sold_qty'})}
                    </th>
                    <th className="fw-bold p-0 px-2 text-nowrap text-uppercase">
                        {formatMessage({id: 'sale_price'})}
                    </th>
                    <th className="fw-bold p-0 px-2 text-nowrap text-uppercase">
                        {formatMessage({id: 'total_sale_price'})}
                    </th>
                    <th className="fw-bold p-0 px-2 text-nowrap text-uppercase">
                        {formatMessage({id: 'dumyah_fees'})}
                    </th>
                    <th className="fw-bold p-0 px-2 text-nowrap text-uppercase">
                        {formatMessage({id: 'net'})}
                    </th>
                    <th className="fw-bold p-0 px-2 text-nowrap text-uppercase">
                        {formatMessage({id: 'order_id'})} / {formatMessage({id: 'return_id'})}
                    </th>
                </tr>
                </thead>

                <tbody>
                {data && Object.values(data).map((item) => (
                    <TransactionReportTableRow
                        showDetails={toggleModal}
                        key={`${item.product_id || '0'}_${item.supplier_order_id || '0'}_${item.type_product_id || '0'}_${item.type}`}
                        item={item}
                    />
                ))
                }
                { transactionTotal && Object.keys(transactionTotal).length > 0 && (
                    <>
                        <tr>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td>{formatMessage({id: 'total_sold_products'})}</td>
                            <td className='green-text td-border'>
                                {String(transactionTotal?.total_order_payment_quantity)}
                            </td>
                            <td className='td-border'></td>

                            <td className='green-text td-border'>
                                {String(transactionTotal?.total_order_payment_sale_price)}
                            </td>
                            <td className='green-text td-border'>
                                {String(transactionTotal?.total_order_payment_dumyah_fees)}
                            </td>
                            <td className='green-text td-border'>
                                {String(transactionTotal?.total_order_payment_net	)}
                            </td>
                        </tr>
                        <tr>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td>{formatMessage({id: 'total_returned_products'})}</td>
                            <td className='td-border'>
                                {String(transactionTotal?.total_refund_quantity)}

                            </td>
                            <td className='td-border'></td>

                            <td className='red-text td-border'>
                                {String(transactionTotal?.total_refund_sale_price)}
                            </td>
                            <td className='red-text td-border'>
                                {String(transactionTotal?.total_refund_dumyah_fees)}
                            </td>
                            <td className='red-text td-border'>
                                {String(transactionTotal?.total_refund_net)}
                            </td>
                            <td></td>
                        </tr>

                        {parseFloat(String(transactionTotal?.total_availability_count || 0)) > 0 && (
                            <tr>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td>
                                    <a
                                        href={`/sales/loss-of-opportunity?filter_start_date=${getDateStart()}&filter_end_date=${getDateEnd()}&filter_remove_reason_id=1`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        {formatMessage({id: 'availability_fees'})}
                                    </a>
                                </td>
                                <td className="red-text td-border">
                                    {String(transactionTotal?.total_availability_count || 0)}
                                </td>
                                <td className="td-border"></td>
                                <td className="td-border"></td>
                                <td className="td-border"></td>
                                <td className="red-text td-border">
                                    {String(transactionTotal?.total_availability_fees_dumyah_fees)}{''}
                                    {currencyString}
                                    {transactionTotal?.availability_fees_flag
                                        ? ''
                                        : formatMessage({ id: 'availability_fees_flag' }, { currency: currencyString })}
                                </td>
                                <td></td>
                            </tr>
                        )}
                        {parseFloat(String(transactionTotal?.total_pickup_fees_count || 0)) > 0 && (
                            <tr>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td>
                                    <a
                                        href={`/orders/pickups_po_return_fees?filter_date_start=${getDateStart()}&filter_date_end=${getDateEnd()}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        {formatMessage({id: 'pickups_fees'})}
                                    </a>
                                </td>
                                <td className="red-text td-border">
                                    {String(transactionTotal?.total_pickup_fees_count)}
                                </td>
                                <td className="td-border"></td>
                                <td className="td-border"></td>
                                <td className="td-border"></td>
                                <td className="red-text td-border">
                                    {String(transactionTotal?.total_pickup_fees_net)} {currencyString}
                                    {transactionTotal?.pickups_fees_flag
                                        ? ''
                                        : formatMessage({ id: 'pickups_fees_flag' }, { currency: currencyString })}
                                </td>
                                <td></td>
                            </tr>
                        )}
                        {/* Shown by the amount, not by the number of ledger rows: a print reversed
                            in full leaves two rows that come to nothing. A credit, from a reversal
                            settled later than its print, is negative and is not a deduction. */}
                        {barcodePrintingNet !== 0 && (
                            <tr>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td>{formatMessage({id: 'barcode_printing_fees'})}</td>
                                <td className={`${barcodePrintingNet > 0 ? 'red-text' : 'green-text'} td-border`}>
                                    {String(transactionTotal?.total_barcode_printing_labels ?? 0)}
                                </td>
                                <td className="td-border"></td>
                                <td className="td-border"></td>
                                <td className="td-border"></td>
                                <td className={`${barcodePrintingNet > 0 ? 'red-text' : 'green-text'} td-border`}>
                                    {String(transactionTotal?.total_barcode_printing_net ?? 0)} {currencyString}
                                </td>
                                <td></td>
                            </tr>
                        )}
                        <tr>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td>{formatMessage({id: 'the_amount_due'})}</td>
                            <td className='td-border'></td>
                            <td className='td-border'></td>
                            <td className='td-border'></td>
                            <td className='td-border'></td>
                            <td className='blue-text td-border'>
                                {String(transactionTotal?.final_net || 0)}{currencyString}
                            </td>
                            <td></td>
                        </tr>
                    </>
                )}
                </tbody>
            </table>
        </>
    )
}

export default TransactionReportTable
